module.exports = __webpack_public_path__ + "static/media/oopsPic.8742508e.png";